import Vue from "vue";
import Vuex from "vuex";
import Authentication from "./modules/auth";
import chart from "./modules/chart";
// import stocks from "./modules/stocks";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: Authentication,
    chart: chart,
    // stocks: stocks
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })]
});
